var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.term)?_c('div',[_c('h3',[_vm._v("Last Revised: "+_vm._s(_vm.term.date))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.term.text)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }